import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InputDialog } from '../../models/dialog.model';
import { DriverService } from 'apps/driver-dashboardfe/src/app/core/services/driver/driver.service';


@Component({
    standalone: false,
    selector: 'octo-update-contact-info-dialog',
    templateUrl: './update-contact-info-dialog.component.html',
    styleUrls: ['./update-contact-info-dialog.component.scss'],
})
export class UpdateContactInfoDialogComponent {
    userSummary: any;

    constructor(
        private modalRef: MatDialogRef<UpdateContactInfoDialogComponent>,
        private driverService: DriverService,
        @Inject(MAT_DIALOG_DATA) public data: InputDialog
    ) {
        this.userSummary = this.data;
    }

    close(): void {
        this.modalRef.close({
            selectedAddress: null,
        });
    }

    markContactInfoUpdated(): void {
        this.driverService.touchContactInfo().subscribe({
            next: (data) => {
            },
            error: (error) => {
                console.log(`Could not mark contact info timestamp update: ${error}`);
            }
    }
        );
        this.close();

    }
}
